"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEmbedLy = void 0;
const formatUrl_1 = require("./formatUrl");
const defaultProps = {
    filterUrls: (v) => v,
    types: ['photo', 'link', 'video', 'rich'],
    // All urls
    urlRegex: /(((https?:\/\/)|(www\.))\S+)/gu,
};
const fetchEmbedLy = (value, { apiUrl, autoplay, chars, filterUrls = defaultProps.filterUrls, key, maxHeight, scheme, types = defaultProps.types, urlRegex = defaultProps.urlRegex, }) => {
    var _a;
    const contentUrls = filterUrls((value === null || value === void 0 ? void 0 : value.match(urlRegex)) || []);
    const contentUrl = (_a = contentUrls === null || contentUrls === void 0 ? void 0 : contentUrls[contentUrls.length - 1]) !== null && _a !== void 0 ? _a : null;
    if (contentUrl) {
        const controller = new AbortController();
        const url = new URL(apiUrl);
        const params = {};
        params.url = contentUrl;
        if (autoplay) {
            params.autoplay = autoplay;
        }
        if (maxHeight) {
            params.maxheight = maxHeight;
        }
        if (scheme) {
            params.scheme = scheme;
        }
        if (chars) {
            params.chars = chars;
        }
        url.search = new URLSearchParams(Object.assign({ key: key || '' }, params)).toString();
        const fetchPromise = fetch(url.toString(), {
            signal: controller.signal,
        })
            .then((res) => res.json())
            .then((res) => {
            if (types.includes(res === null || res === void 0 ? void 0 : res.type)) {
                return Object.assign(Object.assign({}, res), { url: (0, formatUrl_1.formatUrl)(res.url || contentUrl) });
            }
            return null;
        });
        return { controller, fetchPromise };
    }
    return {
        controller: null,
        fetchPromise: Promise.resolve(null),
    };
};
exports.fetchEmbedLy = fetchEmbedLy;
//# sourceMappingURL=fetchEmbedLy.js.map